export default "__VITE_ASSET__Dtu$H8Vb__"